import React, { useEffect, useState } from "react";

export default function YearInReviewPage({ onBack, setUser }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
  let cancelled = false;

  const load = async () => {
    try {
      const token = localStorage.getItem("token");
      const api = process.env.REACT_APP_API_URL;

      const res = await fetch(`${api}/api/me/year-in-review`, {
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });

      const json = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(json?.error || "Failed");
      }

      if (!cancelled) {
        setData(json);
      }
    } catch (e) {
      if (!cancelled) {
        setErr(e?.message || "Failed");
      }
    }
  };

  load();

  return () => {
    cancelled = true;
  };
}, []);

const claimYearInReviewShareReward = async () => {
  try {
    const token = localStorage.getItem("token");
    const api = process.env.REACT_APP_API_URL;

    const res = await fetch(`${api}/api/me/year-in-review/claim-share-reward_2`, {
      method: "POST",
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        "Content-Type": "application/json",
      },
    });

    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
      console.warn("Claim failed:", json);
      return null;
    }

    return json;
  } catch (e) {
    console.warn("Claim error:", e);
    return null;
  }
};

  const stats = data?.stats || {};

  const alreadyShared = data === null ? true : !!data?.yir?.alreadyShared;

  const shareText = () => {
  const s = (x) => (x === null || x === undefined ? 0 : x);

  // ✅ Keeps ALL your stats, just formats nicer for Story captions
  return (
    `→ @taptopiaio_bot\n` + 
    `TAPTOPIA SEASON 3 IS ON!\n` +
    `Come join me and be part of the grind.`
  );
};

const storyWidgetLink = () => {
  const username = (process.env.REACT_APP_TELEGRAM_BOT_USERNAME || "")
    .replace(/^@/, "")
    .trim();

  if (!username) return null;

  const url = `https://t.me/${username}?start=`;

  return {
    url,
    text: "Play Taptopia",
    name: "Play Taptopia",
  };
};


const onShare = async () => {
  if (alreadyShared) return;
  const text = shareText();
  const tg = window?.Telegram?.WebApp;

  let didShare = false;

  try {
    const url = "https://www.taptopia.io/taptopia_season_3.png";

    // 1) Telegram Story
    if (tg && typeof tg.shareToStory === "function") {
      if (!/^https:\/\//i.test(url)) {
        throw new Error(`shareToStory requires an https public URL. Got: ${url}`);
      }

      const widget_link = storyWidgetLink();
      const isPremium = !!tg?.initDataUnsafe?.user?.is_premium;

      tg.shareToStory(url, {
        text, // ✅ FIX: pass string, not function
        ...(isPremium && widget_link ? { widget_link } : {}),
      });

      didShare = true;
    }

    // 2) Telegram fallback share
    else if (tg && typeof tg.openTelegramLink === "function") {
      const username = (process.env.REACT_APP_TELEGRAM_BOT_USERNAME || "")
        .replace(/^@/, "")
        .trim();

      const botLink = username ? `https://t.me/${username}?start=` : "";
      const fullText = botLink
        ? `${text}\n\nPlay Taptopia 👇\n${botLink}`
        : text;

      tg.openTelegramLink(
        `https://t.me/share/url?url=&text=${encodeURIComponent(fullText)}`
      );

      didShare = true;
    }

    // 3) Browser share
    else if (navigator?.share) {
      await navigator.share({ text });
      didShare = true;
    }

    // 4) Clipboard (not a real share → no reward)
    else {
      await navigator.clipboard.writeText(text);
      alert("Copied to clipboard!");
      didShare = false;
    }
  } catch (e) {
    console.warn("Share failed:", e);
    alert(`Share failed: ${e?.message || e}`);
    didShare = false;
  }

  if (didShare) {
    if (!alreadyShared) {
      const result = await claimYearInReviewShareReward();

      //if (result?.runes != null) {
      //  setUser?.((u) => ({ ...u, sparks: result.sparks }));
      //}

      if (result?.runes != null) {
        setUser?.((u) => ({ ...u, runes: result.runes }));
      }

      if (result?.ok || result?.alreadyClaimed) {
        setData((d) => ({
          ...(d || {}),
          yir: {
            ...(d?.yir || {}),
            alreadyShared: true,
            claimedAt: d?.yir?.claimedAt || null,
          },
        }));
      }
    }
  }
};



  return (
    <div style={S.page} style={{paddingLeft: 15, paddingRight: 15, height: "calc(100dvh - 150px - var(--tg-safe-top))", overflow: "auto"}}>
      <div style={S.hero}>
  <div style={S.heroCentered}>
    <div style={S.heroIcon}><img src="/y_1.png" style={{height: 80}}/></div>

    <div className="shadow2" style={S.hTitle}>TapTopia Season 3 Is ON!</div>

    <button
  style={{marginTop: 10}} className="game-button green-button"
  onClick={onShare}
  disabled={alreadyShared}
>
  {alreadyShared ? (
    "Share Again"
  ) : (
    <>
      Share And Earn{" "}
      <img src="/runes.png" style={{ marginLeft: 6, marginRight: 6, verticalAlign: "middle", height: 24 }} /> 10
    </>
  )}
</button>


  </div>
</div>

<img src="/taptopia_season_3.png" style={{width: "100%", borderRadius: "21px"}}/>
     
    </div>
  );
}

const S = {
  page: {
  maxWidth: 500,
  margin: "0 auto",
  padding: "14px 14px 100px",
  color: "#F7E7C6",
  textShadow: "0 1px 0 rgba(0,0,0,0.55)",  
},

  hero: {
    borderRadius: 20,
    padding: 16,
    marginBottom: 14,
    border: "3px solid #42200f",
    background: "#7e4123",
    boxShadow: "0 10px 28px rgba(0,0,0,0.35)",
    backdropFilter: "blur(6px)",
  },
  heroTop: {
    display: "flex",
    justifyContent: "space-between",
    gap: 12,
    alignItems: "center",
  },

  titleRow: { display: "flex", gap: 10, alignItems: "center" },
  titleIcon: {
    fontSize: 26,
    lineHeight: "26px",
    filter: "drop-shadow(0 2px 2px rgba(0,0,0,0.5))",
  },
  hTitle: { fontSize: 21, fontWeight: 600, letterSpacing: 0.3,fontFamily: '"Fredoka", sans-serif', color: "#fff" },
  hYear: { fontSize: 32, fontWeight: 950, color: "#FFD68C", marginTop: 2 },
  hSub: { marginTop: 8, fontSize: 12.5, opacity: 0.9 },

  heroHint: {
    marginTop: 12,
    fontSize: 12.5,
    opacity: 0.9,
    lineHeight: 1.35,
  },

  actions: { display: "flex", gap: 10, flexShrink: 0 },
  btnGhost: {
    borderRadius: 14,
    padding: "10px 14px",
    border: "1px solid rgba(255, 214, 140, 0.22)",
    background: "rgba(0,0,0,0.18)",
    color: "#F7E7C6",
    fontWeight: 900,
  },
  btnPrimary: {
    borderRadius: 14,
    padding: "10px 14px",
    border: "1px solid rgba(255, 214, 140, 0.30)",
    background:
      "linear-gradient(180deg, rgba(255,214,140,0.18) 0%, rgba(255,214,140,0.10) 100%)",
    color: "#FFD68C",
    fontWeight: 950,
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: 12,
  },

  tileIconImg: {
  width: 34,
  height: 34,
  objectFit: "contain",
  marginRight: 8,
},


  tile: {
    borderRadius: 18,
    padding: 14,
    boxShadow: "0 10px 24px rgba(0,0,0,0.25)",
    backdropFilter: "blur(6px)",
    aspectRatio: 250/290,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
        backgroundImage: "url('/y_bg.png')",
        backgroundSize: "cover",
        backgroundRepeat: "repeat",
        backgroundPosition: "center bottom",
  },
  tileTop: {
  color: "#320000",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  marginBottom: 6,
},
  tileLabel: {
  fontSize: 24,          // 32 was huge; adjust if you want
  fontWeight: 600,
  opacity: 0.95,
  letterSpacing: 0.2,
  lineHeight: 1.1,
  textAlign: "center",
},

tileIconImgTop: {
  width: 'auto',
  height: 60,
  objectFit: "contain",
  display: "block",
  margin: "0 auto 6px", // center + space below
},

  tileIcon: { marginRight: 6 },
  tileValue: {
    marginTop: 6,
    fontSize: 32,
    fontWeight: 950,
    lineHeight: 1.0,
    color: "#FFF",
    letterSpacing: 0.2,
  },
  tileSub: { marginTop: 6, fontSize: 12, opacity: 0.82 },

  stateCard: {
    borderRadius: 18,
    padding: 14,
    border: "1px solid rgba(255, 214, 140, 0.16)",
    background: "rgba(10, 6, 4, 0.22)",
    boxShadow: "0 10px 24px rgba(0,0,0,0.22)",
    backdropFilter: "blur(6px)",
  },
  stateTitle: { fontWeight: 950, color: "#FFD68C", marginBottom: 8 },
  stateText: { opacity: 0.9, lineHeight: 1.35 },

  skeletonGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: 12,
  },
  skeletonTile: {
    height: 92,
    borderRadius: 18,
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255, 214, 140, 0.10)",
  },

  details: {
    marginTop: 12,
    borderRadius: 16,
    padding: 12,
    border: "1px dashed rgba(255, 214, 140, 0.22)",
    background: "rgba(0,0,0,0.16)",
  },
  detailsSummary: { cursor: "pointer", fontWeight: 900, color: "#FFD68C" },
  detailsList: { margin: "10px 0 0", paddingLeft: 18, opacity: 0.9 },
  detailsItem: { marginBottom: 6 },

  heroCentered: {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  gap: 6,
},

heroIcon: {
  fontSize: 44,
  lineHeight: "44px",
  marginBottom: 6,
  filter: "drop-shadow(0 2px 2px rgba(0,0,0,0.55))",
},

btnPrimaryLarge: {
  marginTop: 10,
  borderRadius: 16,
  padding: "12px 22px",
  border: "1px solid rgba(255, 214, 140, 0.30)",
  background:
    "linear-gradient(180deg, rgba(255,214,140,0.20) 0%, rgba(255,214,140,0.10) 100%)",
  color: "#FFD68C",
  fontWeight: 950,
  fontSize: 16,
},

};
